/* eslint-disable no-param-reassign, max-params */

import { api } from "jiffy-api";

const initialState = {
  previewUrlAbortSignal: null,
  printableAreas: [],
  waitingForLoading: []
};

const creationModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {
    printableAreas: state => state.printableAreas
  },

  mutations: {},

  actions: {
    async fetchAreas({ state, rootGetters }) {
      const productId = rootGetters["product/productId"];
      const compositionId = rootGetters["product/compositionId"];
      if (state.waitingForLoading.includes(productId)) return new Promise(() => {}); // already loading

      let productArea = state.printableAreas.find(item => item.product_id === productId);

      if (!productArea) {
        state.waitingForLoading = [...state.waitingForLoading, productId];
        [productArea] = await api.printOnDemand.getPrintableAreas({
          product_id: productId
        });
        state.printableAreas = [...state.printableAreas, productArea];
        state.waitingForLoading = state.waitingForLoading.filter(id => id !== productId);
      }

      return productArea.compositions.find(item => item.id === compositionId);
    }
  }
};

export default creationModule;
